/**
 * Created by Анжелика on 13.09.2017.
 */
import React, {Component} from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';

class EpgItem extends Component {

    convertTime(timestamp) {
        let time = new Date(timestamp * 1000);
        return moment(time).format("HH:mm");
    }

    render() {
        const {item, disableTime} = this.props;
        return(
            <div className={"epg-details-item " + (item.current ? 'current ' : '') + (item.notactive ? 'not-active' : '')}>
                {!disableTime && <div className="time">{this.convertTime(item.startTime)}</div>}
                <div className="program">{item.title}</div>
            </div>
        )
    }
}

EpgItem.propTypes = {
    item: PropTypes.shape({
        current: PropTypes.bool,
        notactive: PropTypes.bool,
        startTime: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired
    }).isRequired,
    disableTime: PropTypes.bool
};

export default EpgItem;


// WEBPACK FOOTER //
// ./src/components/EpgItem.js